import { SettingsParser } from "../../../settings-parser";
import { getSizeSettings } from "../../../../../utils/get-size-settings";
import { ColorConverter, ObjectCreator } from "../../../../../../../../web-graphics";
import { CursorSettings } from "../../../../settings/view-objects/plot/content/cursor-settings";

export class CursorPlotContentParser extends SettingsParser {
  constructor() {
    super();
  }

  static createSettings(settings, defaultSettings) {
    if (settings === undefined) {
      if (defaultSettings !== undefined) {
        return ObjectCreator.deepCopy(defaultSettings);
      }
      return undefined;
    }
    let parsedSettings = ObjectCreator.merge(settings, defaultSettings);
    parsedSettings.leftPanelWidth = getSizeSettings(parsedSettings.leftPanelWidth, 0, 0);
    if (parsedSettings.color !== undefined) {
      let parsedColor = ColorConverter.convertToWebglRgba(parsedSettings.color);
      parsedSettings.color = parsedColor.value;
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = CursorPlotContentParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    return new CursorSettings(parsedSettings);
  }
}
